import { createStore, combineReducers, applyMiddleware } from "redux";
import activeMembers from "./activeMembersReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./activeMembersSagas";

const sagaMiddleware = createSagaMiddleware();

export function createReduxStore() {
  const reducers = combineReducers({
    activeMembers
  });
  const composeEnhancers = composeWithDevTools({ activeMembers: "activeMembers" });
  const middleware = composeEnhancers(applyMiddleware(sagaMiddleware));

  let store = createStore(reducers, middleware);
  sagaMiddleware.run(rootSaga)
  return store;
}
